import styled from "styled-components";

export const TutorialCard = styled.div`
    margin: 30px 0;
`